import { render } from "./taocixianwei.vue?vue&type=template&id=5c72b10a&scoped=true"
import script from "./taocixianwei.vue?vue&type=script&lang=js"
export * from "./taocixianwei.vue?vue&type=script&lang=js"

import "./taocixianwei.vue?vue&type=style&index=0&id=5c72b10a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Administrator\\work\\zhongsheng\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c72b10a"]])

export default __exports__